import {Action} from '@ngrx/store';
import * as moment from 'moment';
import {BijbEvent} from '../../../models/bijb-event';

export class GetAnnouncementsAction implements Action {
  public static readonly type = 'GetAnnouncementsAction';

  constructor(public bijbEvent: BijbEvent, public horizon = moment()) {
  }

  public type = GetAnnouncementsAction.type;
}
